import React from 'react';

const Body = () => (
    <>
        <h1>
            <a href="/supply-chain/" className="selected">
                Supply Chain
            </a>
            <span>/</span>
            <a href="/modern-slavery/">Modern Slavery</a>
        </h1>
        <h2>Sustainability</h2>The JD Group recognises the importance of protecting our environment
        and is committed to carrying out our activities with due consideration for their
        environmental impact, particularly with regards to ensuring the efficient use of resources
        and materials, minimising waste and ensuring compliance with relevant legislation and best
        codes of practice.
        <br />
        <br />
        More information on what the JD Group is doing to improve sustainability within its supply
        chain can be found via its most recent{' '}
        <a
            className="link"
            href="https://files.jdplc.com/pdf/reports/_latest.pdf"
            title="Annual Report"
            target="_blank"
            rel="noopener noreferrer"
        >
            Annual Report
        </a>
        .<h2>Ethical Sourcing</h2>The JD Sports Plc Code of Conduct is contained in our private
        label Supplier Terms and Conditions and the minimum standards are defined below. The Group
        will only work with those suppliers who are committed to working to our standard which
        follows those set out by the International Labour Organisation.
        <h2>JD Code of Conduct: Minimum Standards</h2>
        <ul className="list">
            <li>
                Employment is freely chosen – there must be no forced labour, bonded or involuntary
            </li>
            <li>Freedom of Association and the right to collective bargaining must be respected</li>
            <li>Working conditions are safe and hygienic</li>
            <li>Child labour will not be used</li>
            <li>
                Living wages are paid in line with local laws and for a standard working week,
                overtime must be paid at premium rate
            </li>
            <li>Working hours must not be excessive and must be voluntary</li>
            <li>No discrimination</li>
            <li>Regular employment is provided</li>
            <li>No harsh or inhumane treatment is tolerated</li>
            <li>
                The health and safety of workers is paramount in all areas of our business, direct
                or otherwise.
            </li>
        </ul>
        The Group continues to review its policies on ethical sourcing on a regular basis. We
        continuously assess factory ethical and quality management and work with our suppliers to
        improve conditions in our factories.
        <br />
        <br />
        To find out more about what we are doing to protect the people who work within our supply
        chain, please read our Modern Slavery Report which can be found on this website under the{' '}
        <a href="/modern-slavery/" className="link">
            Modern Slavery
        </a>{' '}
        section.
    </>
);

export const content = {
    image: 'https://files.jdplc.com/images/about/supply-chain.jpg',
    body: Body,
};
